export default {
  title: 'Download',
  author: ' iA mobile',
  buttonLabel: 'Install',
  closeButtonLabel: 'Close',
};
